import React from "react";

import createBaseRenderer from "./createBaseRenderer";

import { ZadostPoznamkyItem } from "./";

export default createBaseRenderer({
  name: "zadostPoznamky",
  placeholderText: "23. března 17:18 Váš požadavek byl přijat.",
  content: ({ val }) => (
    <div className="b2b-ZadostPoznamky">
      {val?.length
        ? val.map(item => <ZadostPoznamkyItem key={item.datum} val={item} />)
        : undefined}
    </div>
  )
});
